(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hose-first-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-home-launch]');

    roots.forEach((root) => {
      const slides = Array.from(root.querySelectorAll('[data-launch-slide]'));
      const tabs = Array.from(root.querySelectorAll('[data-launch-target]'));
      const directions = root.querySelectorAll('[data-launch-direction]');
      const order = ['hose', 'drain', 'faucet'];
      let active = 'hose';

      const show = (target) => {
        if (!order.includes(target) || target === active) return;

        slides.forEach((slide) => {
          const selected = slide.dataset.launchSlide === target;
          slide.classList.toggle('is-active', selected);
          slide.setAttribute('aria-hidden', selected ? 'false' : 'true');
        });

        tabs.forEach((tab) => {
          const selected = tab.dataset.launchTarget === target;
          tab.classList.toggle('is-active', selected);
          tab.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        root.dataset.activeProduct = target;
        active = target;
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => show(tab.dataset.launchTarget));
      });

      directions.forEach((button) => {
        button.addEventListener('click', () => {
          const step = Number(button.dataset.launchDirection);
          const currentIndex = order.indexOf(active);
          const nextIndex = (currentIndex + step + order.length) % order.length;
          show(order[nextIndex]);
        });
      });

      const revealItems = root.querySelectorAll('.reveal-on-scroll');

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.12 });

        revealItems.forEach((item) => observer.observe(item));
      } else {
        revealItems.forEach((item) => item.classList.add('is-visible'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
